export default __webpack_public_path__ + "static/media/Preview_desktop_sel.3a581ae3.svg";